// AddDatabaseModalLandingStep.jsx

import React from 'react';

// CSS
import './AddDatabaseModalLandingStep.css';

// Components
import AddDatabaseModalOption from './option/AddDatabaseModalOption';
import { LEGACY_LIBRARY_UI_ENABLED } from 'legacy/legacyFeatureFlags';

/**
 * AddDatabaseModalLandingStep
 *
 * Renders the landing step for choosing how to start a new database.
 *
 * @param {function} onOpenCreateFlow - Opens the create-from-scratch flow.
 * @param {function} onOpenTemplateFlow - Opens the template provisioning flow.
 *
 * @returns {ReactNode} The rendered landing step.
 */
const AddDatabaseModalLandingStep = ({
    onOpenCreateFlow,
    onOpenTemplateFlow,
}) => {

    // ----- RENDER ----- //

    return (
        <div className="add-database-modal-landing">

            {/* LANDING HINT */}
            <div
              className="add-database-modal-landing-hint"
            >
                Choose how you want to set up your new database.
            </div>

            <AddDatabaseModalOption
              iconKey="add_circle"
              title="Create New"
              subtitle="Build a custom collection from scratch"
              onClick={onOpenCreateFlow}
            />

            {LEGACY_LIBRARY_UI_ENABLED ? (
                <AddDatabaseModalOption
                  iconKey="library_books"
                  title="Choose a Template"
                  subtitle="Start from a pre-built collection with common fields"
                  onClick={onOpenTemplateFlow}
                />
            ) : null}
        </div>
    );
};

// Dev Tools
AddDatabaseModalLandingStep.displayName = 'AddDatabaseModalLandingStep';

export default AddDatabaseModalLandingStep;
